import { getResolutionPreset } from '../store.js';
import { bindCameraElements, clearCameraElements, getCameraElements } from './camera-elements.js';

export function initCameraElements(video, canvas) {
  const preset = getResolutionPreset();
  return bindCameraElements(video, canvas, { width: preset.w, height: preset.h });
}

export { clearCameraElements, getCameraElements };
export {
  bootCamera,
  camStream,
  camZoomCap,
  currentZoom,
  leaveRecordingScreen,
  listVideoInputs,
  retryCamera,
  setCamZoom,
  switchCamera
} from '../runtime-core.js';

